import { authApi } from 'api';

const safeMode = false; // Set to true for safe mode, false for actual API calls

export const importCsv = async (meetId, file, importMode = 0) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('importMode', importMode);

  if (safeMode) {
    console.log('SAFE MODE - importCsv API call would be:', {
      method: 'POST',
      url: `/MemberImport/meet-registrations/${meetId}/import-csv`,
      body: {
        fileName: file.name,
        fileSize: file.size,
        importMode: importMode,
      },
    });
    // Return mock response for safe mode
    return {
      data: {
        message: `Registration import job queued successfully (SAFE MODE - Mode: ${importMode === 1 ? 'Merge' : 'Replace'})`,
        importJobId: 'mock-registration-job-id-' + Date.now(),
        totalRecords: 15,
        estimatedDurationMinutes: 2,
        queuePosition: 1,
      },
    };
  }

  return await authApi.post(
    `/MemberImport/meet-registrations/${meetId}/import-csv`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

// Dry-run preview for the meet-registration import: parse + platform-aware resolution, NO writes. Returns the per-row
// resolution (Register / Add visitor / New visitor / Update / No change / Block + reason + diffs + events). dateFormat
// optionally overrides slash-date interpretation ('dayfirst' | 'monthfirst'); omit to auto-detect.
export const previewCsv = async (meetId, file, dateFormat = null) => {
  const formData = new FormData();
  formData.append('file', file);
  if (dateFormat) formData.append('dateFormat', dateFormat);

  return await authApi.post(
    `/MemberImport/meet-registrations/${meetId}/preview-csv`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};

// APPLY the meet-registration import (writes; merge-only). Re-resolves the same file server-side (no stored plan) and
// returns a preview-shaped result report (per-row outcome + the same detail the preview showed). dateFormat optionally
// overrides slash-date interpretation, same as previewCsv.
export const applyCsv = async (meetId, file, dateFormat = null) => {
  const formData = new FormData();
  formData.append('file', file);
  if (dateFormat) formData.append('dateFormat', dateFormat);

  return await authApi.post(
    `/MemberImport/meet-registrations/${meetId}/apply-csv`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};
